import { decodeJwtPayload } from "./decode-jwt";

const roleById = () =>
  new Map<string | undefined, string>([
    [process.env.NEXT_PUBLIC_OHS_ADMIN_ROLE_ID, "ohs_admin"],
    [process.env.NEXT_PUBLIC_OHS_OFFICER_ROLE_ID, "ohs_officer"],
    [process.env.NEXT_PUBLIC_LOCATION_MANAGER_ROLE_ID, "location_manager"],
    [process.env.NEXT_PUBLIC_EMPLOYEE_ROLE_ID, "employee"],
    [process.env.NEXT_PUBLIC_SIFA_ROLE_ID, "sifa"],
    [process.env.NEXT_PUBLIC_AMA_ROLE_ID, "ama"],
    [process.env.NEXT_PUBLIC_EXTERNAL_SIFA_ROLE_ID, "external_sifa"],
  ]);

export function getUserRoleFromToken(token: string | undefined): string | null {
  if (!token) return "employee";

  const role = decodeJwtPayload<{ role?: string }>(token)?.role;
  return role ? (roleById().get(role) ?? null) : null;
}

export function getUserIdFromToken(token: string | undefined): string | null {
  if (!token) return null;

  return decodeJwtPayload<{ id?: string }>(token)?.id ?? null;
}
